import { render, staticRenderFns } from "./SQRank.vue?vue&type=template&id=9ac5526e&scoped=true"
import script from "./SQRank.vue?vue&type=script&lang=js"
export * from "./SQRank.vue?vue&type=script&lang=js"
import style0 from "./SQRank.vue?vue&type=style&index=0&id=9ac5526e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ac5526e",
  null
  
)

export default component.exports